export const REGIONS = {
  AE: "uae",
  SA: "ksa",
} as const;

export type Region = (typeof REGIONS)[keyof typeof REGIONS];
